import React, { useEffect, useState } from 'react'

import useInterval from 'hooks/useInterval/useInterval'

import * as Styles from './styles'

const TOGGLE_DARK_BG_INTERVAL = 1000

const ConnectionStatus = () => {
    const [isDark, setIsDark] = useState(true)
    const [intervalId, setIntervalId] = useState()

    useInterval(() => {
        setIsDark(!isDark)
    }, TOGGLE_DARK_BG_INTERVAL)

    return (
        <Styles.Container isDark={isDark}>
            <Styles.Image src="/img/artefacts/whiteboard/secondaryDevice.svg" />
            <Styles.Text>Whiteboard active on secondary device</Styles.Text>
        </Styles.Container>
    )
}

export default ConnectionStatus
